/* Organization back-office page — for parcours organizers */
const OrganizationPage = () => {
  const [section, setSection] = useState("parcours");
  return (
    <div data-screen-label="08 Organisation — Back-office" style={{display:"flex", minHeight:"100vh"}}>
      <SideNav
        brand="Organisation"
        section={section}
        onChange={setSection}
        items={[
          { group:"Mon parcours en cours", items:[
            ["parcours", "compass", "Sillons d'argile"],
            ["program", "calendar", "Programme"],
            ["map", "map", "Carte des lieux"],
            ["artists-org", "users", "Artistes"],
            ["venues", "pin", "Lieux"],
            ["preview", "eye", "Prévisualiser"]
          ]},
          { group:"Organisation", items:[
            ["org-stats", "chart", "Statistiques"],
            ["org-team", "users", "Équipe"],
            ["org-billing", "sparkle", "Facturation"]
          ]}
        ]}
      />
      <div style={{flex:1, padding:"36px 48px"}}>
        <OrgHeader/>
        {section === "parcours" && <OrgParcoursEditor/>}
        {section === "program"  && <OrgProgramEditor/>}
        {section === "map"      && <OrgMapEditor/>}
        {section === "artists-org" && <OrgArtistsManager/>}
        {section === "venues"   && <OrgVenuesManager/>}
        {section === "preview"  && <OrgPreview/>}
        {section === "org-stats"   && <OrgStats/>}
        {section === "org-team"    && <OrgTeam/>}
        {section === "org-billing" && <OrgBilling/>}
      </div>
    </div>
  );
};

const OrgHeader = () => (
  <div className="row between" style={{marginBottom:36}}>
    <div className="stack gap-2">
      <div className="row gap-3">
        <span className="mono muted">Centre culturel de Genappe</span>
        <span className="badge badge-live">
          <span className="chip-dot" style={{background:"currentColor"}}/> En cours
        </span>
      </div>
      <h2 style={{fontSize:42}}>Sillons <span className="serif-it">d'argile</span></h2>
    </div>
    <div className="row gap-3">
      <button className="btn btn-light"><Icon name="eye" size={14}/> Prévisualiser</button>
      <button className="btn btn-light" style={{color:"var(--terracotta-d)"}}>Dépublier</button>
      <button className="btn btn-primary"><Icon name="check" size={14}/> Publié</button>
    </div>
  </div>
);

/* === Parcours editor === */
const OrgParcoursEditor = () => {
  const [step, setStep] = useState(0);
  const steps = ["Informations","Image principale","Programme","Lieux & carte","Artistes","Publication"];
  return (
    <div className="stack gap-5">
      {/* Stepper */}
      <div className="panel" style={{padding:24}}>
        <div className="row between">
          {steps.map((s,i) => (
            <button key={s} onClick={() => setStep(i)} className="row gap-3" style={{
              padding:"6px 0", color: i===step ? "var(--ink)" : "var(--ink-mute)"
            }}>
              <span style={{
                width:28, height:28, borderRadius:50,
                background: i<step ? "var(--sage)" : i===step ? "var(--ink)" : "var(--paper-3)",
                color: i<=step ? "var(--paper)" : "var(--ink-mute)",
                display:"flex", alignItems:"center", justifyContent:"center",
                fontSize:12, fontFamily:"var(--font-mono)"
              }}>{i<step ? "✓" : (i+1)}</span>
              <span style={{fontSize:13, fontWeight: i===step?500:400}}>{s}</span>
              {i < steps.length-1 && <span style={{
                width:46, height:1, background:"var(--line)", margin:"0 8px"
              }}/>}
            </button>
          ))}
        </div>
      </div>

      <div className="row gap-5">
        <div className="panel" style={{flex:2, padding:36}}>
          <h3 style={{marginBottom:8}}>Informations du parcours</h3>
          <p className="muted" style={{marginTop:0, maxWidth:560}}>
            Le titre, le pitch et les dates apparaissent sur la page publique du parcours.
          </p>

          <div className="stack gap-5" style={{marginTop:32}}>
            <Field label="Titre du parcours" value="Sillons d'argile" hint="Apparaît en très gros sur la page publique"/>
            <Field label="Slug" value="sillons-argile" hint="parcours.bw/parcours/sillons-argile" mono/>
            <div className="row gap-4">
              <Field label="Date de début" value="24 mai 2026" inline/>
              <Field label="Date de fin"   value="2 juin 2026" inline/>
            </div>
            <FieldArea
              label="Pitch court"
              value="Dix jours pour suivre la trace de la terre cuite, du tour au feu, des céramistes de la vallée de la Dyle aux bois de Villers."
              hint="120 à 200 caractères. Apparaît en exergue."
            />
            <FieldArea
              label="Description complète"
              value="Le parcours rassemble douze artistes autour d'un même geste, celui de mettre les mains dans la matière. Ateliers ouverts, démonstrations, cuissons collectives au bois, et une exposition principale dans les ruines de l'abbaye."
              rows={6}
            />
            <div className="row gap-4">
              <Field label="Région" value="Sud Brabant wallon"/>
              <Field label="Organisateur" value="Centre culturel de Genappe"/>
            </div>
            <div className="row gap-4">
              <Field label="Téléphone" value="+32 67 77 16 27"/>
              <Field label="Email public" value="parcours@ccgenappe.be"/>
            </div>
            <div className="row gap-3" style={{marginTop:12}}>
              <button className="btn btn-light">Annuler</button>
              <button className="btn btn-primary" onClick={() => setStep(s => Math.min(s+1, steps.length-1))}>
                Sauvegarder et continuer <Icon name="arrow-right" size={14}/>
              </button>
            </div>
          </div>
        </div>

        <div className="stack gap-4" style={{flex:1}}>
          <div className="panel" style={{padding:24}}>
            <span className="eyebrow">Aperçu URL</span>
            <div className="card" style={{marginTop:14, padding:14, background:"var(--paper-2)"}}>
              <div className="mono muted">parcours.bw/parcours/</div>
              <div className="mono" style={{fontSize:13, color:"var(--ink)"}}>sillons-argile</div>
            </div>
          </div>

          <div className="panel" style={{padding:24}}>
            <span className="eyebrow">Statut de publication</span>
            <div className="stack gap-3" style={{marginTop:14}}>
              {[
                ["Informations principales", true],
                ["Image principale", true],
                ["Programme", true],
                ["Au moins 1 lieu", true],
                ["Au moins 3 artistes", true],
                ["Infos pratiques", false]
              ].map(([k,ok]) => (
                <div key={k} className="row gap-2">
                  <span style={{
                    width:18, height:18, borderRadius:50, flexShrink:0,
                    background: ok ? "var(--sage)" : "var(--paper-3)",
                    color: ok ? "var(--paper)" : "var(--ink-mute)",
                    display:"flex", alignItems:"center", justifyContent:"center"
                  }}>{ok ? <Icon name="check" size={10} stroke={3}/> : "·"}</span>
                  <span style={{fontSize:13, color: ok?"var(--ink)":"var(--ink-mute)"}}>{k}</span>
                </div>
              ))}
              <div className="divider" style={{margin:"4px 0"}}/>
              <div className="row between">
                <span className="mono muted">Complétion</span>
                <span style={{fontSize:14}}>83%</span>
              </div>
              <div style={{height:6, borderRadius:99, background:"var(--paper-3)", position:"relative"}}>
                <div style={{position:"absolute", inset:0, right:"17%", background:"var(--terracotta)", borderRadius:99}}/>
              </div>
            </div>
          </div>

          <div className="panel" style={{padding:24, background:"var(--ink)", color:"var(--paper-warm)"}}>
            <div className="mono" style={{color:"var(--paper-3)"}}>Le saviez-vous</div>
            <p style={{fontSize:14, lineHeight:1.5, marginTop:10}}>
              Les parcours avec une photo principale de qualité reçoivent 3,2× plus de visites. Préférez une image carrée, lumineuse, et qui montre une œuvre en train de se faire.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const Field = ({ label, value, hint, inline, mono }) => (
  <label className="stack gap-2" style={{flex: inline?1:"unset", display:"block"}}>
    <span className="mono muted">{label}</span>
    <input className="input input-square" defaultValue={value} style={mono ? {fontFamily:"var(--font-mono)"} : null}/>
    {hint && <span className="mono muted" style={{fontSize:10}}>{hint}</span>}
  </label>
);

const FieldArea = ({ label, value, rows=3, hint }) => (
  <label className="stack gap-2" style={{display:"block"}}>
    <span className="mono muted">{label}</span>
    <textarea className="input input-square" defaultValue={value} rows={rows}
      style={{resize:"vertical", minHeight: rows*22+24, padding:"14px 18px", borderRadius:14}}/>
    {hint && <span className="mono muted" style={{fontSize:10}}>{hint}</span>}
  </label>
);

/* === Program editor === */
const OrgProgramEditor = () => {
  const D = window.PA_DATA;
  return (
    <div className="row gap-5">
      <div className="stack gap-4" style={{flex:1}}>
        <div className="panel" style={{padding:24}}>
          <div className="row between">
            <h3>Programme du parcours</h3>
            <button className="btn btn-primary btn-sm"><Icon name="plus" size={12}/> Ajouter un événement</button>
          </div>
          <p className="muted" style={{marginTop:8}}>Glissez-déposez pour réorganiser. Les événements sont regroupés par journée.</p>
        </div>

        {D.programSillons.map((d,i) => (
          <div key={i} className="panel" style={{padding:0, overflow:"hidden"}}>
            <div className="row between" style={{padding:"18px 24px", borderBottom:"1px solid var(--line-soft)", background:"var(--paper-2)"}}>
              <div className="row gap-3">
                <span className="chip chip-active">{d.label}</span>
                <span className="serif" style={{fontSize:22}}>{d.day}</span>
              </div>
              <div className="row gap-2">
                <button className="btn btn-light btn-sm"><Icon name="plus" size={12}/> Événement</button>
                <button className="btn btn-icon btn-light" style={{width:32, height:32}}><Icon name="edit" size={12}/></button>
              </div>
            </div>
            <div>
              {d.events.map((e,j) => (
                <div key={j} className="row between" style={{
                  padding:"16px 24px",
                  borderBottom: j < d.events.length-1 ? "1px dashed var(--line)" : "none"
                }}>
                  <div className="row gap-4">
                    <span style={{
                      cursor:"grab", color:"var(--ink-faint)",
                      fontFamily:"var(--font-mono)", fontSize:12
                    }}>⋮⋮</span>
                    <span className="mono" style={{width:80}}>{e.time}</span>
                    <div className="stack gap-1">
                      <span style={{fontSize:14}}>{e.title}</span>
                      <span className="mono muted">{e.where}</span>
                    </div>
                  </div>
                  <div className="row gap-3">
                    <span className="chip" style={{padding:"3px 10px", fontSize:11}}>{e.tag}</span>
                    <button className="btn btn-icon btn-light" style={{width:30, height:30}}><Icon name="edit" size={11}/></button>
                    <button className="btn btn-icon btn-light" style={{width:30, height:30, color:"var(--terracotta-d)"}}><Icon name="trash" size={11}/></button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <aside className="stack gap-4" style={{width:300, flexShrink:0}}>
        <div className="panel" style={{padding:24}}>
          <span className="eyebrow">Résumé</span>
          <div className="stack gap-3" style={{marginTop:18}}>
            <div className="row between"><span className="mono muted">Journées</span><span style={{fontSize:14}}>5</span></div>
            <div className="row between"><span className="mono muted">Événements</span><span style={{fontSize:14}}>14</span></div>
            <div className="row between"><span className="mono muted">Premier événement</span><span style={{fontSize:14}}>24 mai · 18:00</span></div>
            <div className="row between"><span className="mono muted">Dernier événement</span><span style={{fontSize:14}}>2 juin · 20:00</span></div>
          </div>
        </div>
        <div className="panel" style={{padding:24}}>
          <span className="eyebrow">Tags d'événements</span>
          <div className="row gap-2 wrap" style={{marginTop:14}}>
            {["vernissage","démo","atelier","performance","concert","talk","visite","convivial"].map(t => (
              <span key={t} className="chip" style={{fontSize:11}}>{t}</span>
            ))}
            <button className="chip" style={{borderStyle:"dashed", color:"var(--ink-mute)"}}>+ Tag</button>
          </div>
        </div>
      </aside>
    </div>
  );
};

/* === Map editor === */
const OrgMapEditor = () => {
  const D = window.PA_DATA;
  const mapRef = useRef(null);
  const [selected, setSelected] = useState(D.venues[0]);

  useEffect(() => {
    if (!mapRef.current || !window.ol) return;
    const features = D.venues.slice(0,8).map(v => new ol.Feature({
      geometry: new ol.geom.Point(ol.proj.fromLonLat(v.lonlat)),
      venue: v
    }));
    const vs = new ol.source.Vector({ features });
    const layer = new ol.layer.Vector({
      source: vs,
      style: new ol.style.Style({
        image: new ol.style.Circle({
          radius: 10,
          fill: new ol.style.Fill({ color: "#C5694A" }),
          stroke: new ol.style.Stroke({ color: "#F7F1E5", width: 3 })
        })
      })
    });
    const map = new ol.Map({
      target: mapRef.current,
      controls: ol.control.defaults.defaults({ attribution: true }),
      layers: [
        window.baseTileLayer(),
        layer
      ],
      view: new ol.View({ center: ol.proj.fromLonLat([4.55, 50.65]), zoom: 10 })
    });
    map.on("click", (e) => {
      const f = map.forEachFeatureAtPixel(e.pixel, f=>f);
      if (f) setSelected(f.get("venue"));
    });
    return () => map.setTarget(undefined);
  }, []);

  return (
    <div className="row gap-5" style={{alignItems:"stretch"}}>
      <div className="panel" style={{flex:1, padding:0, overflow:"hidden", height:680}}>
        <div className="row between" style={{padding:"18px 24px", borderBottom:"1px solid var(--line-soft)"}}>
          <h3>Carte des lieux</h3>
          <div className="row gap-2">
            <button className="btn btn-light btn-sm"><Icon name="plus" size={12}/> Ajouter un lieu</button>
            <button className="btn btn-light btn-sm"><Icon name="compass" size={12}/> Tracer un itinéraire</button>
          </div>
        </div>
        <div className="ol-map" ref={mapRef} style={{height:"calc(100% - 67px)"}}/>
      </div>

      <aside className="stack gap-4" style={{width:340, flexShrink:0}}>
        <div className="panel stack gap-3" style={{padding:0, overflow:"hidden"}}>
          <div className="ph" style={{height:140, position:"relative", background:"var(--paper-3)", overflow:"hidden"}}>
            <img src={window.PA_DATA.photo("venue-" + selected.id, 800, 400)} alt={selected.name}
                 style={{width:"100%", height:"100%", objectFit:"cover", display:"block"}}
                 onError={(e)=>{e.currentTarget.style.display="none";}}/>
            <span className="ph-label">Photo lieu</span>
            <button className="btn btn-light btn-sm" style={{position:"absolute", top:10, right:10}}>
              <Icon name="edit" size={11}/> Photo
            </button>
          </div>
          <div className="stack gap-3" style={{padding:20}}>
            <div className="serif" style={{fontSize:26, lineHeight:1.1}}>{selected.name}</div>
            <div className="row gap-2">
              <span className="chip">{selected.type}</span>
              <span className="chip"><Icon name="pin" size={11}/> {selected.commune}</span>
            </div>
            <Field label="Adresse" value={`Rue de l'Atelier 12, 1470 ${selected.commune}`}/>
            <div className="row gap-3">
              <Field label="Latitude" value={selected.lonlat[1].toFixed(4)} inline/>
              <Field label="Longitude" value={selected.lonlat[0].toFixed(4)} inline/>
            </div>
            <FieldArea label="Description courte" value="Atelier ouvert pendant toute la durée du parcours. Démonstrations sur rendez-vous." rows={3}/>
            <div className="row gap-2">
              <button className="btn btn-primary btn-sm" style={{flex:1, justifyContent:"center"}}>Sauvegarder</button>
              <button className="btn btn-light btn-sm" style={{color:"var(--terracotta-d)"}}><Icon name="trash" size={12}/></button>
            </div>
          </div>
        </div>

        <div className="panel" style={{padding:0, overflow:"hidden"}}>
          <div className="row between" style={{padding:"14px 18px", borderBottom:"1px solid var(--line-soft)"}}>
            <span className="eyebrow">Lieux ({D.venues.slice(0,8).length})</span>
            <button className="mono" style={{color:"var(--terracotta)"}}>+ Ajouter</button>
          </div>
          <div className="stack" style={{maxHeight:280, overflowY:"auto"}}>
            {D.venues.slice(0,8).map((v,i) => (
              <button key={v.id} onClick={() => setSelected(v)}
                      className="row gap-3" style={{
                        padding:"12px 18px", textAlign:"left",
                        borderBottom: "1px dashed var(--line)",
                        background: selected.id===v.id ? "var(--paper-2)" : "transparent"
                      }}>
                <span style={{
                  width:26, height:26, borderRadius:50, background:"var(--terracotta)",
                  color:"var(--paper-warm)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0
                }}><Icon name="pin" size={12}/></span>
                <div className="stack gap-1" style={{flex:1, minWidth:0}}>
                  <span style={{fontSize:13, lineHeight:1.2}}>{v.name}</span>
                  <span className="mono muted">{v.commune}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </aside>
    </div>
  );
};

/* === Artists manager === */
const OrgArtistsManager = () => {
  const D = window.PA_DATA;
  return (
    <div className="stack gap-5">
      <div className="panel" style={{padding:0, overflow:"hidden"}}>
        <div className="row between" style={{padding:"22px 28px"}}>
          <div className="stack gap-2">
            <h3>Artistes participants ({D.artists.length})</h3>
            <p className="muted" style={{margin:0, fontSize:14}}>Invitez vos artistes par email — ils renseigneront leur fiche eux-mêmes.</p>
          </div>
          <div className="row gap-2">
            <button className="btn btn-light btn-sm"><Icon name="filter" size={12}/> Filtrer</button>
            <button className="btn btn-primary btn-sm"><Icon name="plus" size={12}/> Inviter un artiste</button>
          </div>
        </div>
        <table className="table">
          <thead>
            <tr>
              <th></th>
              <th>Artiste</th>
              <th>Discipline</th>
              <th>Commune</th>
              <th>Fiche</th>
              <th>Œuvres</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {D.artists.map((a,i) => (
              <tr key={a.id}>
                <td style={{width:48}}>
                  <div className={"ph " + a.ph} style={{width:40, height:40, borderRadius:50}}/>
                </td>
                <td>{a.name}</td>
                <td><span className="chip">{a.disc}</span></td>
                <td>{a.commune}</td>
                <td>{i%3===2 ? <span className="badge badge-soon">À compléter</span> : <span className="badge badge-live">Complète</span>}</td>
                <td className="mono muted">{8 + (i%5)}</td>
                <td style={{textAlign:"right"}}>
                  <div className="row gap-2" style={{justifyContent:"flex-end"}}>
                    <button className="btn btn-light btn-sm"><Icon name="edit" size={11}/></button>
                    <button className="btn btn-light btn-sm" style={{color:"var(--terracotta-d)"}}><Icon name="trash" size={11}/></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

/* === Venues manager === */
const OrgVenuesManager = () => {
  const D = window.PA_DATA;
  return (
    <div className="stack gap-5">
      <div className="row between">
        <h3>Lieux du parcours</h3>
        <button className="btn btn-primary btn-sm"><Icon name="plus" size={12}/> Ajouter un lieu</button>
      </div>
      <div style={{display:"grid", gridTemplateColumns:"repeat(3, 1fr)", gap:20}}>
        {D.venues.slice(0,9).map(v => (
          <div key={v.id} className="card" style={{overflow:"hidden"}}>
            <div className="ph ph-stripes" style={{height:120, position:"relative"}}>
              <div className="ph-label">Photo</div>
              <span className="badge badge-live" style={{position:"absolute", top:10, right:10, background:"rgba(247,241,229,0.9)", color:"var(--ink)"}}>
                Publié
              </span>
            </div>
            <div className="stack gap-2" style={{padding:18}}>
              <div className="serif" style={{fontSize:22, lineHeight:1.1}}>{v.name}</div>
              <div className="mono muted">{v.type} · {v.commune}</div>
              <div className="row between" style={{marginTop:8}}>
                <span className="mono muted">{3 + Math.floor(Math.random()*4)} artistes</span>
                <button className="btn btn-light btn-sm">Éditer →</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const OrgPreview = () => (
  <div className="stack gap-5">
    <div className="panel" style={{padding:24}}>
      <div className="row between">
        <div className="stack gap-2">
          <span className="eyebrow">Aperçu public</span>
          <h3>Voici ce que voit le public.</h3>
        </div>
        <div className="row gap-2">
          <button className="btn btn-light btn-sm"><Icon name="external" size={12}/> Ouvrir dans un nouvel onglet</button>
          <a href="/parcours/sillons-argile" className="btn btn-primary btn-sm">Voir la vraie page →</a>
        </div>
      </div>
    </div>
    {/* Browser frame */}
    <div className="card" style={{overflow:"hidden", padding:0}}>
      <div className="row between" style={{padding:"14px 20px", borderBottom:"1px solid var(--line-soft)", background:"var(--paper-2)"}}>
        <div className="row gap-2">
          <span style={{width:12, height:12, borderRadius:50, background:"#E07765"}}/>
          <span style={{width:12, height:12, borderRadius:50, background:"#E4B85B"}}/>
          <span style={{width:12, height:12, borderRadius:50, background:"#7E9579"}}/>
        </div>
        <div className="card" style={{padding:"6px 16px", fontSize:12, borderRadius:99, background:"var(--paper-warm)"}}>
          parcours.bw/parcours/sillons-argile
        </div>
        <div style={{width:60}}/>
      </div>
      <div style={{height:560, position:"relative", overflow:"hidden", background:"var(--paper)"}}>
        <div style={{transform:"scale(0.55)", transformOrigin:"top left", width:"182%"}}>
          <div style={{padding:40}}>
            <div className="row between">
              <Brand small/>
              <div className="row gap-4 mono">
                <span>Parcours</span><span>Carte</span><span>Artistes</span>
              </div>
            </div>
            <h1 style={{fontSize:160, marginTop:60, letterSpacing:"-0.02em"}}>Sillons <span className="serif-it">d'argile</span></h1>
            <p style={{fontSize:24, marginTop:24, maxWidth:700, color:"var(--ink-soft)"}}>
              Dix jours pour suivre la trace de la terre cuite, du tour au feu, des céramistes de la vallée de la Dyle aux bois de Villers.
            </p>
            <div className="card" style={{height:600, borderRadius:32, marginTop:48, overflow:"hidden"}}>
              <img src={window.PA_DATA.photo("sillons-argile-hero", 1800, 1100)} alt=""
                   style={{width:"100%", height:"100%", objectFit:"cover", display:"block"}}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const OrgStats = () => (
  <div className="stack gap-6">
    <div className="row gap-4">
      <AdminKpi label="Visiteurs cette semaine" value="1 248" delta="+24%" chart={<SparkLine/>}/>
      <AdminKpi label="Itinéraires créés" value="92" delta="+18%" chart={<SparkLine color="var(--ochre)"/>}/>
      <AdminKpi label="Partages" value="218" delta="+8%" chart={<SparkLine color="var(--sage)"/>}/>
      <AdminKpi label="Favoris" value="174" delta="+11%" chart={<SparkLine color="var(--brick)"/>}/>
    </div>
    <div className="panel" style={{padding:28}}>
      <h3 style={{marginBottom:24}}>Fréquentation jour par jour</h3>
      <BigChart/>
    </div>
    <div className="row gap-4">
      <div className="panel" style={{flex:1, padding:28}}>
        <h4>Top lieux</h4>
        {["Atelier Vasseur", "Ruines de Villers", "Grange Rose", "Place de Genappe", "Cloître ouest"].map((v,i) => (
          <div key={v} className="row between" style={{padding:"12px 0", borderBottom:"1px dashed var(--line)"}}>
            <span style={{fontSize:14}}>{v}</span>
            <span className="mono muted">{(420-i*65)} visites</span>
          </div>
        ))}
      </div>
      <div className="panel" style={{flex:1, padding:28}}>
        <h4>Origine du trafic</h4>
        {[["Direct","42%"],["Recherche Google","28%"],["Instagram","14%"],["Facebook","9%"],["Newsletter","7%"]].map(([k,v]) => (
          <div key={k} className="row between" style={{padding:"12px 0", borderBottom:"1px dashed var(--line)"}}>
            <span style={{fontSize:14}}>{k}</span>
            <span className="mono muted">{v}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const OrgTeam = () => (
  <div className="panel" style={{overflow:"hidden"}}>
    <div className="row between" style={{padding:"22px 28px"}}>
      <h3>Équipe de l'organisation</h3>
      <button className="btn btn-primary btn-sm"><Icon name="plus" size={12}/> Inviter</button>
    </div>
    <table className="table">
      <thead><tr><th>Membre</th><th>Rôle</th><th>Email</th><th>Dernière connexion</th><th></th></tr></thead>
      <tbody>
        {[
          ["Sophie Levêque", "Admin", "sophie@ccgenappe.be", "il y a 2 min"],
          ["François Wauters", "Éditeur", "francois@ccgenappe.be", "il y a 1 h"],
          ["Émilie Renard", "Éditeur", "emilie@ccgenappe.be", "hier"],
          ["Léon Hubaux", "Lecteur", "leon@ccgenappe.be", "il y a 5 j"]
        ].map((r,i) => (
          <tr key={i}>
            <td><div className="row gap-3"><div className={"ph ph-paint-"+((i%6)+1)} style={{width:34,height:34,borderRadius:50}}/>{r[0]}</div></td>
            <td><span className="chip">{r[1]}</span></td>
            <td className="mono muted">{r[2]}</td>
            <td className="mono muted">{r[3]}</td>
            <td style={{textAlign:"right"}}><button className="btn btn-icon btn-light" style={{width:32, height:32}}><Icon name="edit" size={11}/></button></td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const OrgBilling = () => (
  <div className="stack gap-5">
    <div className="row gap-4">
      <div className="panel pricing-feature" style={{flex:2, padding:36, position:"relative", overflow:"hidden"}}>
        <BrushBlob color="var(--terracotta)" style={{
          position:"absolute", width:240, height:240, top:-60, right:-60, opacity:0.5
        }}/>
        <div className="row between" style={{position:"relative"}}>
          <div className="stack gap-3">
            <span className="eyebrow" style={{color:"var(--paper-3)"}}>Plan actuel</span>
            <div className="row gap-3">
              <div className="serif" style={{fontSize:44}}>Pro</div>
              <span className="chip">49€/mois</span>
            </div>
            <p style={{maxWidth:420, fontSize:14, lineHeight:1.5, color:"var(--paper-3)"}}>
              Parcours illimités, statistiques avancées, export PDF du programme, domaine personnalisé.
            </p>
          </div>
          <div className="stack gap-3" style={{alignItems:"flex-end"}}>
            <span className="mono" style={{color:"var(--paper-3)"}}>Prochaine facture</span>
            <span className="serif" style={{fontSize:32}}>15 juin</span>
            <button className="btn btn-accent">Changer de plan</button>
          </div>
        </div>
      </div>

      <div className="panel" style={{flex:1, padding:28}}>
        <span className="eyebrow">Mode de paiement</span>
        <div className="row gap-3" style={{marginTop:18}}>
          <div style={{width:48, height:32, background:"var(--ink)", borderRadius:6}}/>
          <div className="stack gap-1">
            <span style={{fontSize:14}}>•••• 4242</span>
            <span className="mono muted">Visa · expire 08/28</span>
          </div>
        </div>
        <button className="btn btn-light btn-sm" style={{marginTop:16, width:"100%", justifyContent:"center"}}>Mettre à jour</button>
      </div>
    </div>

    <div className="panel" style={{overflow:"hidden"}}>
      <div className="row between" style={{padding:"22px 28px"}}>
        <h3>Factures</h3>
        <button className="btn btn-light btn-sm">Télécharger tout (PDF)</button>
      </div>
      <table className="table">
        <thead><tr><th>Date</th><th>Numéro</th><th>Montant</th><th>Statut</th><th></th></tr></thead>
        <tbody>
          {[
            ["15 mai 2026","INV-2026-005","49,00 €","Payée"],
            ["15 avril 2026","INV-2026-004","49,00 €","Payée"],
            ["15 mars 2026","INV-2026-003","49,00 €","Payée"],
            ["15 février 2026","INV-2026-002","49,00 €","Payée"],
            ["15 janvier 2026","INV-2026-001","49,00 €","Payée"]
          ].map((r,i)=>(
            <tr key={i}>
              <td className="mono">{r[0]}</td><td className="mono">{r[1]}</td><td>{r[2]}</td>
              <td><span className="badge badge-live">{r[3]}</span></td>
              <td style={{textAlign:"right"}}><button className="btn btn-light btn-sm">PDF</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

window.OrganizationPage = OrganizationPage;
